/** @format */

import React from 'react';
import { Grid, Button, Typography, List, ListItem } from '@mui/material';
import { Link } from 'react-router-dom';

export function Agreement(props) {
  const { setAgreementStatus } = props;

  return (
    <Grid container direction="row" alignItems="center" spacing={4}>
      <Grid item xs={12}>
        <List>
          <ListItem>
            <Typography>
              1-مدل های پرداختی سرویس ها به دو روش پرداخت در لحظه و خرید اشتراک است. در صورتیکه
              تمایل دارید هزینه سرویس شما به روش خرید اشتراک انجام شود، ابتدا اشتراک مورد نظر خود را
              تعریف کنید
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              2- هر سرویس باید حداقل عضو یک مجموعه سرویس باشد. در صورت نیاز پیش از آغاز تعریف سرویس{' '}
              <Link to="#">مجموعه سرویس</Link> مورد نظر خود را تعریف کنید
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              3-.هر سرویس از طریق یکی از کلید های اتصال با مشتریان خود ارتباط برقرار می کند. در صورت
              نیاز پیش از آغاز تعریف سرویس کلید های اتصال مورد نظر خود را تعریف کنید.
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              4-درآمد واصله از فروش سرویس های شما دررده های درآمدی واریز خواهند شد. در صورت نیاز پیش
              از تعریف سرویس رده درآمدی مورد نظر خود را تعریف کنید.
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              5-سرویس ها برای عرضه و نمایش در وب سایت پادیوم نیاز به مستندات جامع حاوی روش استفاده و
              توضیحات فنی دارند. پس از تعریف وب سرویس لطفا مستندات فنی مربوط به آن را تکمیل کنید.
            </Typography>
          </ListItem>
          <ListItem>
            <Typography>
              6-هر نسخه از سرویس می تواند از مستندات قبلی استفاده کند . یا اگر تغییراتی در مستند
              قبلی منجر به تغییر نسخه مستند می شود ، وضعیت مستند مربوط به آن را از قسمت مستندات
              تعیین کنید تا فرآیند نمایش آن بر روی وب سایت با اختلال مواجه نشود.
            </Typography>
          </ListItem>
        </List>
      </Grid>
      <Grid item xs={12} container justifyContent="flex-end">
        <Button
          type="submit"
          color="primary"
          variant="contained"
          onClick={() => setAgreementStatus(true)}
        >
          برای تعریف سرویس جدید آماده ام
        </Button>
      </Grid>
    </Grid>
  );
};

